module.exports = __webpack_public_path__ + "static/media/adc-white.196653c0.png";